import React, { useState } from "react";
import { Translate } from "../../../language";
import { Switch } from "react-router-dom";
import { RouteWithSubRoutes } from "../../../config/Router";
import { useHistory } from "react-router-dom";
import NewPost from "../../Post/NewPost/NewPost";
import TabProfile from "../TabProfile/TabProfile";
import Button from "../../../utils/components/Button/Button";
import circle from "../../../assets/img/circulogris.png";
import useModal from "../../../utils/hooks/useModal";
import "./Profile.css";
import Options from "../../../utils/components/Options/Options";
import ModalReportPost from "../../ReportContent/ModalReportPost";
import ModalPictureProfile from "../../ModalPictureProfile";
import localStorage from "../../../utils/hooks/useLocalStorage";


const Profile = ({
  urlProfile = circle,
  currentDepartment,
  followed,
  currentCity,
  isNameBig = false,
  secondName,
  firstName,
  privateData,
  followers,
  friends,
  slogan,
  routes,
  _id,
  _idEc,
  addFriend,
  startFollow,
  stopFollow,
  acceptFriendRequest,
  cancelFriendRequest,
  deleteFriend,
  relationBetween,
  userInfo,
  aspiration,
  haveInventory,
  type,
  birthDate,
  email,
  gender,
  phone,
  points,
  userRank,
  isSelf
}) => {

  let classFullName = 'full-name-image-name'

  if (isNameBig) {
    classFullName = 'text-center'
  }


  let id = _id;
  if (userInfo.representativeID) {
    if (userInfo.representativeID.state === 2) {
      id = userInfo.representativeID._id
    }
  }
  if (userInfo.franchiseID) {
    if (userInfo.franchiseID.state === 2) {

      id = userInfo.franchiseID._id
    }
  }

  const history = useHistory();
  const [, isShowReport, setIsShowReport] = useModal(false);
  const [isShowNewPhoto, setIsShowNewPhoto] = useState(false)


  const currentRank = userRank.find(rank => { return rank.current });

  //verify type of propfile

  const theme = (className, classNameDefault) => {
    return type !== "" ? className + '-' + type : classNameDefault ? classNameDefault : ""
  }
  const getBirthdate = (birthdate) => {
    let arrayBirthdate = (new Date(birthdate).toLocaleDateString()).split('/');
    return (arrayBirthdate[0] + ' de ' + getMonth(arrayBirthdate[1]));

  }

  const getMonth = (monthNumber) => {
    switch (monthNumber) {
      case '1':
        return 'enero'
      case '2':
        return 'febrero'
      case '3':
        return 'marzo'
      case '4':
        return 'abril'
      case '5':
        return 'mayo'
      case '6':
        return 'junio'
      case '7':
        return 'julio'
      case '8':
        return 'agosto'
      case '9':
        return 'septiembre'
      case '10':
        return 'octubre'
      case '11':
        return 'noviembre'
      case '12':
        return 'diciembre'
      default:
        return ''
    }
  }

  const getTextStyle = (user, textType) => {
    if (user.representativeID && type === 'em') {
      if (textType === 'title') {
        return 'color-purple-dark'
      }
      else {
        return 'text-white'
      }
    }
    else if (type === 'et') {
      if (textType === 'title') {
        return 'text-white'
      }
      else {
        return 'color-purple-dark'
      }
    }

    else {
      if (textType === 'title') {
        return 'text-color-primary'
      }
      else {
        return 'text-color-green'
      }
    }
  }

  let shouldFriendRequest = (type !== "et" && type !== "wh") && ((localStorage().getItem("typeProfile") !== "franchise") && (localStorage().getItem("typeProfile") !== "warehouse"))

  return (
    <div className="content-profile container-page hide-overflow-x scroll-menu">
      <div
        style={{ overflow: "auto" }}
        className={`fit-content-heigth content-profile-info ${theme('content-profile-info')} scroll-menu`}
      >
        <ModalReportPost
          closeModal={() => { setIsShowReport(false) }}
          reportType="user"
          displayModal={isShowReport}
          idReported={_id}
        />
        <ModalPictureProfile
          newPhoto
          displayModal={isShowNewPhoto}
          closeModal={() => {
            setIsShowNewPhoto(false)

          }}
          seturlProfilePicture={() => { }}
          setFile={() => { }}
        />
        <Options
          type={`vertical ${theme("profile-opt-color")}`}
          options={[
            _id === localStorage().getItem("idUser")
              ? {
                text: Translate("editProfile", "es"),
                onClick: (e) => {
                  e.stopPropagation();
                  if (localStorage().getItem("typeProfile") === "franchise") {
                    history.push("/EditFranchisee");
                  } else {
                    history.push("/PersonalInfo");
                  }

                },
              }
              : {
                text: Translate("report", "es"),
                onClick: (e) => {
                  e.stopPropagation();
                  setIsShowReport(true)
                },
              },
            _id === localStorage().getItem("idUser") && {
              text: Translate("changeProfilePicture", "es"),
              onClick: (e) => {
                e.stopPropagation();
                setIsShowNewPhoto(true)
              },
            },
            (_id === localStorage().getItem("idUser") && haveInventory) && {
              text: Translate("inventory", "es"),
              onClick: (e) => {
                e.stopPropagation();
                history.push("/inventory");
              },
            },
          ]}
        />
        <img
          alt="img"
          className={`profile-picture-img ${theme("profile-picture-img")}`}
          onError={(e) => (e.target.src = circle)}
          src={urlProfile}
        ></img>
        <div
          style={{ overflow: "auto", overflowY: "hidden" }}
          className={`${classFullName} full-name-profile scroll-menu`}
        >
          <div className={`first-name-image-name ${theme("first-name-image-name")}`}>{firstName}</div>
          <div className={`second-name-image-name ${theme("second-name-image-name")}`}>{secondName}</div>
        </div>
        <div className={`slogan-profile ${theme("slogan-profile")}`}>{aspiration}</div>
        {privateData.gender === 1 &&
          <div className={`${getTextStyle(userInfo, 'normal')}`}>{gender}</div>}
        <div>
          {(type === 'et' && userInfo?.franchiseID?.urlCatalogue) && (
            <a target="_blank" href={userInfo.franchiseID.urlCatalogue} >Ver Catalogo</a>
          )}
        </div>
        <div className="content-social-data-profile">
          {
            (type !== 'et' && type !== 'wh') && (
              <div className="content-social-data-info">
                <div className={`text-social-data ${theme("text-social-data")}`}>
                  {friends}
                </div>
                <div className={`${theme("text-color", "text-color-green")}`}>
                  {Translate("friends", "es")}
                </div>
              </div>
            )
          }

          <div className="content-social-data-info">
            <div className={`text-social-data ${theme("text-social-data")}`}>
              {followers}
            </div>
            <div className={`${theme("text-color", "text-color-green")}`}>
              {Translate("followers", "es")}
            </div>
          </div>
          <div className="content-social-data-info">
            <div className={`text-social-data ${theme("text-social-data")}`}>
              {followed}
            </div>
            <div className={`${theme("text-color", "text-color-green")}`}>
              {Translate("followed", "es")}
            </div>
          </div>
        </div>

        {_id !== localStorage().getItem("idUser") && (
          <>
            {relationBetween ? (
              relationBetween.firstID === _id ? (
                <>
                  {shouldFriendRequest &&
                    <>
                      {relationBetween.sendRequestSecond &&
                        !relationBetween.requestStatus ? (
                        <Button
                          classNameContent="button-social-profile"
                          text={Translate("cancelFriendRequest", "es")}
                          onClick={() => {
                            cancelFriendRequest(id, relationBetween);
                          }}
                        />
                      ) : relationBetween.sendRequestFirst &&
                        !relationBetween.requestStatus ? (
                        <>
                          <Button
                            classNameContent="button-social-profile"
                            text={Translate("rejectFriendRequest", "es")}
                            onClick={() => {
                              cancelFriendRequest(id, relationBetween);
                            }}
                          />
                          <Button
                            classNameContent="button-social-profile"
                            text={Translate("acceptFriendRequest", "es")}
                            onClick={() => {
                              acceptFriendRequest(id, relationBetween);
                            }}
                          />
                        </>
                      ) : relationBetween.areFriends ? (
                        <Button
                          classNameContent="button-social-profile"
                          text={Translate("deleteFriend", "es")}
                          onClick={() => {
                            deleteFriend(id, relationBetween);
                          }}
                        />
                      ) : (
                        <Button
                          classNameContent="button-social-profile"
                          text={Translate("addFriend", "es")}
                          onClick={() => {
                            addFriend(id, relationBetween);
                          }}
                        />
                      )}
                    </>
                  }
                  {relationBetween.isFollowerSecond ? (
                    <Button
                      classNameContent="button-social-profile"
                      text={Translate("unFollow", "es")}
                      onClick={() => {
                        stopFollow(id, relationBetween);
                      }}
                    />
                  ) : (
                    <Button
                      classNameContent="button-social-profile"
                      text={Translate("follow", "es")}
                      onClick={() => {
                        startFollow(id, relationBetween);
                      }}
                    />
                  )}
                </>
              ) : (
                <>
                  {
                    shouldFriendRequest && <>
                      {relationBetween.sendRequestFirst &&
                        !relationBetween.requestStatus ? (
                        <Button
                          classNameContent="button-social-profile"
                          text={Translate("cancelFriendRequest", "es")}
                          onClick={() => {
                            cancelFriendRequest(id, relationBetween);
                          }}
                        />
                      ) : relationBetween.sendRequestSecond &&
                        !relationBetween.requestStatus ? (
                        <>
                          <Button
                            classNameContent="button-social-profile"
                            text={Translate("rejectFriendRequest", "es")}
                            onClick={() => {
                              cancelFriendRequest(id, relationBetween);
                            }}
                          />
                          <Button
                            classNameContent="button-social-profile"
                            text={Translate("acceptFriendRequest", "es")}
                            onClick={() => {
                              acceptFriendRequest(id, relationBetween);
                            }}
                          />
                        </>
                      ) : relationBetween.areFriends ? (
                        <Button
                          classNameContent="button-social-profile"
                          text={Translate("deleteFriend", "es")}
                          onClick={() => {
                            deleteFriend(id, relationBetween);
                          }}
                        />
                      ) : (
                        <Button
                          classNameContent="button-social-profile"
                          text={Translate("addFriend", "es")}
                          onClick={() => {
                            addFriend(id, relationBetween);
                          }}
                        />
                      )}
                    </>
                  }
                  {relationBetween.isFollowerFirst ? (
                    <Button
                      classNameContent="button-social-profile"
                      text={Translate("unFollow", "es")}
                      onClick={() => {
                        stopFollow(id, relationBetween);
                      }}
                    />
                  ) : (
                    <Button
                      classNameContent="button-social-profile"
                      text={Translate("follow", "es")}
                      onClick={() => {
                        startFollow(id, relationBetween);
                      }}
                    />
                  )}
                </>
              )
            ) : (
              <>
                {
                  shouldFriendRequest && <Button
                    classNameContent="button-social-profile"
                    text={Translate("addFriend", "es")}
                    onClick={() => {
                      addFriend(id, relationBetween);
                    }}
                  />
                }
                <Button
                  classNameContent="button-social-profile"
                  text={Translate("follow", "es")}
                  onClick={() => {
                    startFollow(id, relationBetween);
                  }}
                />
              </>
            )}
          </>
        )}

        <div className={`fit-content-heigth footer-profile-info ${theme("footer-profile-info")}`}>

          <div className="row centerItems" style={{
            whiteSpace: 'pre'
          }}>
            {privateData.ubication === 1 &&
              <div className={`${getTextStyle(userInfo, 'normal')} text-center`}>{[currentCity, currentDepartment].filter(place => place).length > 0 && <div className={`${getTextStyle(userInfo, 'title')}`}> {Translate("liveIn", "es")}</div>}{" " + [currentCity, currentDepartment].filter(place => place).join(", ")}</div>}
          </div>
          {privateData.email === 1 &&
            <div className="text-center">
              <div className={`${getTextStyle(userInfo, 'title')}`}>Email</div>
              <div className={`${getTextStyle(userInfo, 'normal')}`}>{email}</div>
            </div>
          }
          {privateData.birthDate === 1 &&
            <div className="text-center">
              <div className={`${getTextStyle(userInfo, 'title')}`}>Cumpleaños</div>
              <div className={`${getTextStyle(userInfo, 'normal')}`}>
                {birthDate && getBirthdate(birthDate)}
              </div>
            </div>
          }
          {privateData.phone === 1 &&
            <div className="text-center">
              <div className={`${getTextStyle(userInfo, 'title')}`}>Teléfono</div>
              <div className={`${getTextStyle(userInfo, 'normal')}`}>
                {phone}
              </div>
            </div>
          }


          {
            (type === '' || type === 'em') && (
              <div className="row centerItems">
                <img src={currentRank?.image.url.origin} height={90} alt={currentRank?.name} />
                <div className="">{points}</div>
              </div>
            )
          }




        </div>
      </div >

      <div className="content-profile-navegation">
        <div className="content-new-post-tab-bar">
          {isSelf && !history.location.pathname.split("/")[3] && <NewPost isPostCampaign={!!_idEc} _idEc={_idEc} />}
          <TabProfile _id={_id} type={type} _idEc={_idEc} isSelf={isSelf} />
        </div>
        <Switch>
          {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
          ))}
        </Switch>
      </div>
    </div >
  );
};

export default Profile;
